import { Text } from '@chakra-ui/react';

export const EllipsisText = ({ text, length = 25, ...props }) => {
  const displayText = text?.substr(0, length);
  const showEllipsis = text?.length > length;
  return (
    <Text {...props}>
      {displayText}
      {showEllipsis && '...'}
    </Text>
  );
};
